//packages\shared-utils\src\main\keyCodes.ts
export const EXTRA_KEYS_MATRIX = {
  media: [
    [
      8303, 8304, 8374, 8373, 8375, 8397, 8418, 8425, 8426, 8579, 8594, 8596,
      8739,
    ],
  ],
  mouse: [
    [16384, 16640, 16896, 17152, 17920, 18176, 18432, 18688, 18945, 19201],
  ],
  light: [
    [
      62208, 62209, 62210, 62211, 62212, 62213, 62214, 62215, 62216, 62224,
      62225, 62226, 62227, 62228, 62229, 62230, 62231, 62232,
    ],
  ],
  control: [[61952, 61953, 61954, 61957, 61958, 61959, 61960]],
  /** Gamma75 改键：穿透 / Fn1 / Fn2 */
  special: [[1, 61697, 61698]],
  macro: [
    [
      62720, 62721, 62722, 62723, 62724, 62725, 62726, 62727, 62728, 62729,
      62730, 62731, 62732, 62733, 62734, 62735,
    ],
  ],
  advancedOther: [
    [
      61952, 61953, 61954, 61955, 61957, 61958, 61959, 61960, 61961, 1, 61696,
      61697, 61698, 61699,
    ],
  ],
};

export const EXTRA_KEYS_MATRIX_HUAFENDA = {
  media: [[8374, 8373, 8375, 8397, 8418, 8425, 8426, 8579, 8594, 8596]],
  mouse: [[16640, 16896, 17152]],
  light: [[62208, 62209, 62210, 62211, 62212, 62213, 62215, 62224, 62225]],
  control: [[61952]],
  macro: [
    [
      62720, 62721, 62722, 62723, 62724, 62725, 62726, 62727, 62728, 62729,
      62730, 62731, 62732, 62733, 62734, 62735,
    ],
  ],
};

/**
 * 智慧无限 DK87/CX87：改键面板可选扩展键
 * - 灯效：仅主键盘背光 FUNC（无侧灯/LOGO/D1 等）
 * - 控制：不含 Win/Mac 切换与多套板载（固件仅 1 套板载）
 */
export const EXTRA_KEYS_MATRIX_ZHWX = {
  media: [
    [8303, 8304, 8374, 8373, 8375, 8397, 8418, 8425, 8426, 8579, 8594, 8596],
  ],
  light: [[62208, 62209, 62210, 62211, 62212, 62213, 62215]],
  control: [[61952, 61961]],
  macro: [
    [
      62720, 62721, 62722, 62723, 62724, 62725, 62726, 62727, 62728, 62729,
      62730, 62731, 62732, 62733, 62734, 62735, 62736, 62737, 62738, 62739,
    ],
  ],
};

/**
 * SDCX DK63：改键面板仅基础 / 多媒体 / 宏（不支持灯效、控制、鼠标映射）
 */
export const EXTRA_KEYS_MATRIX_SDCX = {
  media: [
    [
      8303, 8304, 8374, 8373, 8375, 8397, 8418, 8425, 8426, 8579, 8594, 8596,
      8739,
    ],
  ],
  macro: [
    [
      62720, 62721, 62722, 62723, 62724, 62725, 62726, 62727, 62728, 62729,
      62730, 62731, 62732, 62733, 62734, 62735,
    ],
  ],
};

export const EXTRA_KEYS_MATRIX_BEIYING = {
  media: [[8397, 33554819, 8418, 8374, 8373, 8425, 8426]],
  /** 贝盈工具键：浏览器 / 计算器 / 邮件 / 我的电脑 */
  tool: [[8739, 8594, 33554826, 8596]],
  mouse: [[16640, 16896, 17152]],
  macro: [
    [
      62720, 62721, 62722, 62723, 62724, 62725, 62726, 62727, 62728, 62729,
      62730, 62731, 62732, 62733, 62734, 62735,
    ],
  ],
};
